import type { EPGEntryDto } from "$src/core/models/dto";
import programTimeRangeMs from "$src/core/utils/epg/program-time-range-ms";

/** Keep programs that overlap `[dayStart, dayEnd)` (half-open day window). */
const filterProgramsForDay = (
  programs: EPGEntryDto[],
  dayStartMs: number,
  dayEndMs: number,
): EPGEntryDto[] =>
  programs.filter((entry) => {
    const range = programTimeRangeMs(entry);
    if (!range) {
      return false;
    }
    return range.start < dayEndMs && range.end > dayStartMs;
  });

export default filterProgramsForDay;
